import React from "react";
import { Box, Grid, Typography, Button } from "@mui/material";
import { keyframes } from "@mui/system";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import DiamondOutlinedIcon from "@mui/icons-material/DiamondOutlined";

import diamondImg from "../assests/diamond.webp";
import ringImg from "../assests/ring.webp";
import BestSellers from "./bestSellers";
import { useNavigate } from "react-router-dom";

const bounce = keyframes`
  0%, 100% { transform: translate(-50%, 0); }
  50% { transform: translate(-50%, -12px); }
`;

const RingSection: React.FC = () => {
  const navigate = useNavigate();
  return (
    <>
      <Box
        sx={{
          backgroundColor: "#F5F5F5",
          py: { xs: 6, md: 10 },
          px: { xs: 2, sm: 4, md: 8 },
        }}
      >
        <Grid
          container
          alignItems="center"
          justifyContent="center"
          columnSpacing={{ md: 8 }}
          rowSpacing={{ xs: 6, md: 0 }}
          sx={{ textAlign: "center", maxWidth: 1400, mx: "auto" }}
        >
          {/* LEFT: VISUAL stone focus */}
          <Grid
            item
            xs={12}
            md={6}
            sx={{
              order: { xs: 2, md: 1 },
              display: "flex",
              justifyContent: "center",
            }}
          >
            <Box
              sx={{
                position: "relative",
                width: { xs: 260, sm: 320, md: 380, lg: 420 },
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              {/* Ring base you can swap this to any stone cluster later */}
              <Box
                component="img"
                loading="lazy"
                decoding="async"
                src={ringImg}
                alt="Stone setting"
                sx={{
                  width: "69%",
                  height: "auto",
                  display: "block",
                  zIndex: 1,
                }}
              />
              {/* Floating diamond representing the zodiac stone */}
              <Box
                component="img"
                loading="lazy"
                decoding="async"
                src={diamondImg}
                alt="Center stone"
                sx={{
                  position: "absolute",
                  top: {
                    xs: "-4%",
                    sm: "-4%",
                    md: "-4%",
                    lg: "-7%",
                    xl: "-4%",
                  },
                  width: {
                    xs: "51%",
                    sm: "51%",
                    md: "51%",
                    lg: "51%",
                    xl: "51%",
                  },
                  left: "52%",
                  transform: "translateX(-50%)",
                  animation: `${bounce} 2.2s ease-in-out infinite`,
                  zIndex: 2,
                  pointerEvents: "none",
                }}
              />
            </Box>
          </Grid>

          {/* RIGHT: TEXT zodiac stones only */}
          <Grid item xs={12} md={6} sx={{ order: { xs: 1, md: 2 } }}>
            <DiamondOutlinedIcon
              sx={{
                fontSize: 40,
                mb: 2,
                display: "block",
                mx: "auto",
                color: "black",
              }}
            />
            <Typography
              variant="h3"
              sx={{
                fontWeight: 600,
                mb: 1.5,
                fontSize: { xs: "1.8rem", md: "2.2rem", lg: "3rem" },
                fontFamily: `"Bodoni Moda", serif`,
                color: "black",
                textTransform: "uppercase",
              }}
            >
              Your Signature Stone
            </Typography>
            <Typography
              sx={{
                maxWidth: 560,
                mx: "auto",
                mb: 4,
                fontSize: { xs: "1rem" },
                lineHeight: 1.5,
                color: "black",
              }}
            >
              Discover the gemstone that aligns with your zodiac sign. Each
              stone is chosen for its unique energy, symbolism and brilliance –
              a personal talisman that tells your story.
            </Typography>
            <Button
              onClick={() => navigate("/zodiac-stones")}
              variant="outlined"
              endIcon={<ArrowForwardIcon />}
              sx={{
                borderRadius: "999px",
                px: 4,
                py: 1.4,
                fontSize: { xs: "0.95rem" },
                color: "black",
                borderColor: "black",
                textTransform: "uppercase",
                "&:hover": {
                  backgroundColor: "black",
                  borderColor: "black",
                  color: "#C3BAAF",
                },
              }}
            >
              Choose Your Stone
            </Button>
          </Grid>
        </Grid>
      </Box>
      <BestSellers />
    </>
  );
};

export default RingSection;
